/*
 * 百度 - 热搜榜（服务端路由）
 */
export async function fetchBaiduHot() {
  const res = await fetch('/server-api/baidu')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
